<template>
  <div class="locations">
    <h1>{{ $t('whereDoYouWork') }}</h1>

    <div class="locations-container">
      <div
        v-for="(item, value) in locationTagArgs"
        :key="value"
        class="location-tag"
        :class="{ selected: locationTagArgs[value].checked }"
        :style="{
          boxShadow: 'inset 0 0 0 1px ' + locationTagArgs[value].color,
          color: locationTagArgs[value].checked ? 'white' : locationTagArgs[value].color,
        }"
        @click="changeTag(value)"
      >
        <div>
          <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg" class="icon">
            <path
              v-if="value == 'office'"
              :fill="locationTagArgs[value].checked ? 'white' : locationTagArgs[value].color"
              d="M16 1a2 2 0 0 1 2 2v4.636L28 14v15H2V3a2 2 0 0 1 2-2h12Zm0 1.25H4a.75.75 0 0 0-.743.648L3.25 3v24.75h13.5V3a.75.75 0 0 0-.648-.743L16 2.25Zm2.25 7.027V27.75h8.5V14.686l-8.5-5.409Zm-4.125 12.598v1.25h-8.25v-1.25h8.25Zm0-4v1.25h-8.25v-1.25h8.25Zm0-4v1.25h-8.25v-1.25h8.25Zm0-4v1.25h-8.25v-1.25h8.25Zm0-4v1.25h-8.25v-1.25h8.25Z"
            />
            <path
              v-else-if="value == 'remote'"
              :fill="locationTagArgs[value].checked ? 'white' : locationTagArgs[value].color"
              d="M14.688 3.518 23.17 12H24v.83l3.857 3.857-.884.884L24 14.598V26H6V13.972l-3.598 3.6-.884-.884L6 12.204V12h.205zm0 1.766-7.442 7.442V16h.004v8.75h15.5V13.348l-8.063-8.064z"
            />
            <path
              v-else-if="value == 'mix'"
              :fill="locationTagArgs[value].checked ? 'white' : locationTagArgs[value].color"
              d="M27 1a2 2 0 0 1 2 2v26H3v-9.476l-1.707 1.708-.883-.884L10.85 9.906 18.946 18H19v.054l2.293 2.294-.883.884L19 19.82v7.929h8.75V3a.75.75 0 0 0-.648-.743L27 2.25H15a.75.75 0 0 0-.743.648L14.25 3v10.186L13 11.936V3a2 2 0 0 1 2-2h12Zm-9.791 17.03H4.494l-.011.011v1.209H4.25v8.5h13.5v-8.5h-.531v-1.209l-.01-.011Zm3.79 3.845h4.126v1.25h-4.126v-1.25Zm0-4h4.126v1.25h-2.938L21 17.937v-.062Zm-10.148-6.202L4.524 18h12.655l-6.328-6.327Zm14.274 2.202v1.25h-7.25v-1.25h7.25Zm0-4v1.25h-8.25v-1.25h8.25Zm0-4v1.25h-8.25v-1.25h8.25Z"
            />
          </svg>
        </div>
        <div class="plus">
          <svg v-if="!locationTagArgs[value].checked" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.5 4c.276142 0 .5.223858.5.5V12h7.5c.24546 0 .449608.176875.491944.410124L21 12.5c0 .276142-.223858.5-.5.5H13v7.5c0 .24546-.176875.449608-.410124.491944L12.5 21c-.276142 0-.5-.223858-.5-.5v-7.501L4.5 13c-.24546 0-.449608-.176875-.491944-.410124L4 12.5c0-.276142.223858-.5.5-.5l7.5-.001V4.5c0-.24546.176875-.449608.410124-.491944z"
              :fill="locationTagArgs[value].color"
              fill-rule="evenodd"
            />
          </svg>
          <img v-else :src="require('@/assets/_desktop/_shared/checkmark-24px-thin-white.svg')" />
        </div>
        <h3>{{ item.name }}</h3>
        <p>{{ item.desc }}</p>
        <div
          class="tag-background"
          :style="{
            background: locationTagArgs[value].color,
            opacity: locationTagArgs[value].checked ? 1 : 0,
          }"
        />
      </div>

      <!-- <div
        v-for="(el, index) in locationTags()"
        :key="el.value"
        class="location-tag"
        :class="{ selected: locationTagArgs[el.value].checked }"
        :style="{
          boxShadow: 'inset 0 0 0 1px ' + colorsHashArray(6 - index).hash,
          color: locationTagArgs[el.value].checked ? 'white' : colorsHashArray(6 - index).hash,
          
        }"
        @click="changeTag(el,index)"
      >
        <span>{{ el.name }}</span>
        <svg
          v-if="!locationTagArgs[el.value].checked"
          width="24" 
          height="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.5 4c.276142 0 .5.223858.5.5V12h7.5c.24546 0 .449608.176875.491944.410124L21 12.5c0 .276142-.223858.5-.5.5H13v7.5c0 .24546-.176875.449608-.410124.491944L12.5 21c-.276142 0-.5-.223858-.5-.5v-7.501L4.5 13c-.24546 0-.449608-.176875-.491944-.410124L4 12.5c0-.276142.223858-.5.5-.5l7.5-.001V4.5c0-.24546.176875-.449608.410124-.491944z" 
            :fill="colorsHashArray(6 - index).hash"
            fill-rule="evenodd"
          />
        </svg>
        <img
          v-else
          :src="require('@/assets/_desktop/_shared/checkmark-24px-thin-white.svg')"
        >
        <div
          class="tag-background"
          :style="{ 
            background: colorsHashArray(6 - index).hash,
            opacity: locationTagArgs[el.value].checked ? 1 : 0
          }"
        />
      </div> -->
    </div>

    <div class="next-back-buttons">
      <!-- <button
      class="clavo-button big secondary"
      @click="previousStage"
      >
      {{ $t('back') }}
      </button> -->
      <button class="clavo-button big primary" @click="nextStage">
        {{ $t('next') }}
      </button>
    </div>
  </div>
</template>

<script>
import Constants from '@/components/Constants'
import ParseFunctions from '@/components/ParseFunctions'
import EventBus from '@/EventBus'

export default {
  name: 'LocationsWhereYouWork',
  mixins: [Constants, ParseFunctions],
  props: {
    teamId: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      colorsLength: this.colorsHashArray(false).length,
      locationTagArgs: {},
    }
  },
  created() {
    let i
    for (i = 0; i < this.locationTags().length; i++) {
      this.locationTagArgs[this.locationTags()[i].value] = {
        checked: false,
        color: this.colorsHashArray(6 - i).hash,
        name: this.locationTags()[i].name,
      }
    }
    this.locationTagArgs['office'].desc = this.$t('officeDesc')
    this.locationTagArgs['remote'].desc = this.$t('remoteDesc')
    this.locationTagArgs['mix'] = {
      checked: false,
      color: this.colorsHashArray(6 - i).hash,
      name: this.$t('hybrid'),
      desc: this.$t('hybridDesc'),
    }
  },
  methods: {
    changeTag(el) {
      for (const value in this.locationTagArgs) {
        if (value == el) {
          this.locationTagArgs[el].checked = !this.locationTagArgs[el].checked
        } else {
          this.locationTagArgs[value].checked = false
        }
      }
      this.$forceUpdate()
    },
    previousStage() {
      this.$emit('push-to-previous-stage', this.locationTagArgs)
    },
    async nextStage() {
      let locations = []
      // let locationsAmount = 0

      if (this.locationTagArgs['mix'].checked) {
        this.locationTagArgs['office'].checked = true
        this.locationTagArgs['remote'].checked = true
        this.locationTagArgs['mix'].checked = false
      }

      const numOfPossibleColors = this.colorsHashArray().length

      for (const value in this.locationTagArgs) {
        if (this.locationTagArgs[value].checked) {
          let color = this.colorsHashArray(Math.floor(Math.random() * numOfPossibleColors)).hash
          locations.push({
            type: value,
            color: color,
          })
        }
      }

      // for (let i = 0; i < this.locationTags().length; i++) {
      //   if(this.locationTagArgs[this.locationTags()[i].value].checked){
      //     // locationsAmount++
      //     locations.push({
      //       type: this.locationTags()[i].value,
      //       color: this.locationTagArgs[this.locationTags()[i].value].color
      //     })
      //   }
      // }

      if (locations.length > 0) {
        // console.log('generateLocationsArgs', this.teamId, locations)
        await this.generateLocations(this.teamId, locations)
        this.$emit('push-to-next-stage', this.locationTagArgs)
      } else {
        EventBus.$emit('new-info-bar-msg', {
          msg: this.$t('pleaseSelectAtLeastOneWorkplace'),
          error: true,
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.locations-container {
  margin-top: 48px;
  margin-bottom: 40px;
  display: flex;
  flex-wrap: nowrap;
  @include respond-below(xs) {
    flex-direction: column;
  }

  .location-tag {
    padding: 20px 20px;
    cursor: pointer;
    user-select: none;
    margin-right: 20px;
    margin-bottom: 20px;
    position: relative;
    flex: 1;
    @include respond-below(xs) {
      margin-right: 0px;
    }
    h3 {
      font-family: $bold;
      font-size: 16px;
      letter-spacing: 0.2px;
      margin: 18px 0 12px;
    }
    p {
      font-family: $regular;
      font-size: 16px;
      letter-spacing: 0;
      line-height: 22px;
    }
    .plus {
      position: absolute;
      right: 20px;
      top: 20px;
    }

    .tag-background {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      transition: opacity 0.15s cubic-bezier(0.4, 0.14, 0.52, 1);
      z-index: -1;
    }
    &:hover {
      .tag-background {
        opacity: 0.15 !important;
      }
    }
    &.selected:hover {
      .tag-background {
        opacity: 1 !important;
      }
    }
    span,
    img,
    svg {
      position: relative;
      z-index: 10;
    }
    span {
      font-family: $bold;
      letter-spacing: 0.2px;
    }

    img,
    svg {
      vertical-align: text-bottom;
    }
  }
}
.clavo-button {
  display: block;
  @include respond-below(sm) {
    width: 100%;
  }
}
</style>